<template lang="pug">
  main
    NavBarCorpo
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.is-multiline.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Editar terminal  &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .column.is-12
          .field
            label.label Nombre de la terminal
              .control
                input.input.is-primary(
                  type='text',
                  placeholder='Nombre',
                  v-model="terminal.name"
                )
        //- .column.is-12
        //-   .field
        //-     label.label identificador
        //-       .control
        //-         input.input.is-primary(
        //-           type='text',
        //-           placeholder='Identificador',
        //-           v-model="terminal.identifier"
        //-           maxlength="10"
        //-         )
        //- .column.is-12
        //-   .field
        //-     label.label Dirección
        //-       .control
        //-         input.input.is-primary(
        //-           type='text',
        //-           placeholder='Dirección',
        //-           v-model="terminal.address"
        //-         )
        .columns(v-show="datosFaltantes.length > 0")
          .column.is-12
            .notification
              button.delete(@click="closeNotification")
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes" :key="datosF")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}

        a.button.is-black.is-rounded.is-block(@click="checkForm()")
          | Guardar
</template>

<script>
  import Loader from "@/components/shared/Loader.vue"
  import NavBarCorpo from '@/components/layout/NavBarCorpo.vue'
  import { mapState } from 'vuex'
  import sasisopaAPI from "@/services/axios_sasisopa.js";
  export default {
    name: 'EditTerminalSASISOPA',
    components: { Loader, NavBarCorpo },

    data() {
      return {
        isLoading: true,
        terminal: {
          name: '',
          identifier: '',
          address: ''
        },
        datosFaltantes: [],
        terminals: [],
      }
    },
    methods: {
      iniciarComponente () {
        // Código para iniciar componente
        this.isLoading = false
        this.fetchData();
      },
      async fetchData() {
      try {
        this.isLoading = true;
        const response = await sasisopaAPI.getTerminales();
        this.terminals = response.data;
        const terminalEncontrado = this.terminals.find(terminal => terminal.id == this.$route.params.id);
        if (terminalEncontrado){
          this.terminal.name = terminalEncontrado.name;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },
      backPage() {
        this.$router.back()
      },

      checkForm() {
      this.isLoading = true;
        this.closeNotification();
        this.datosFaltantes = []; // Limpiar datos faltantes antes de verificar
        if (this.terminal.name) {
        // if (this.terminal.name && this.terminal.identifier && this.terminal.address) {
          this.guardarForm()
        } else {
          if (!this.terminal.name) {
            this.datosFaltantes.push('El nombre es requerido.')
          }
          // if (!this.terminal.identifier) {
          //   this.datosFaltantes.push('El identificador es requerido.')
          // }
          // if (!this.terminal.address) {
          //   this.datosFaltantes.push('La dirección es requerida.')
          // }
        }
      },
      async guardarForm() {
        try {
          const data = {
            name: this.terminal.name,
            id:this.$route.params.id ,
            // address: this.terminal.address
          };
          const response = await sasisopaAPI.UpdateTerminal(data);
          this.$router.push('/Apartado/SASISOPA');
          return response;
        } catch (error) {
          this.datosFaltantes.push(error|| 'Error al guardar la terminal.');
          throw error;
        }
      },

      closeNotification() {
        this.datosFaltantes = []
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos'])
    }
  }
</script>

<style lang="scss" scoped>
.input {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: border-color 0.3s;
}
.input:focus {
  border-color:  #057D8D;
  outline: none;
}
.container {
  padding: 2rem;
}
.field {
  margin-bottom: 1.5rem
}
input.input {
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/sasisopa/EditTerminalSASISOPA.vue